export function sessionChangedError() {
  return Object.assign(new Error('登录状态已更新，请重试'), { code: 'SESSION_CHANGED' })
}

export function getLandingPath(routes = []) {
  const hasHome = routes.some(route => route.name === 'shouye' ||
    (route.children || []).some(child => child.name === 'home'))
  return hasHome ? '/home' : '/welcome'
}

export function isChunkLoadError(error) {
  return /Loading (?:CSS )?chunk [\w-]+ failed|ChunkLoadError|CSS_CHUNK_LOAD_FAILED/i.test(
    String(error && (error.message || error)))
}

export function authErrorMessage(error) {
  if (isChunkLoadError(error)) return '页面暂时未能加载，请检查网络后点击重试。'
  if (error && error.code === 'ECONNABORTED') return '连接超时，请稍后重试。'
  if (error && error.message === 'Network Error') return '网络连接异常，请检查网络后重试。'
  if (error && error.code === 401) return '登录已失效，请重新登录。'
  return error && error.message ? error.message : '暂时无法进入系统，请稍后重试。'
}

// 仅记录阶段、耗时与结果，不记录账号、口令、Token 或业务数据，也不上传。
export async function measureAuthStage(stage, operation) {
  const started = Date.now()
  let result = 'success'
  try {
    return await operation()
  } catch (error) {
    result = error && error.code === 'SESSION_CHANGED' ? 'cancelled' : 'error'
    throw error
  } finally {
    if (typeof window !== 'undefined') {
      const timings = window.__JL_AUTH_TIMINGS__ || []
      timings.push({ stage, durationMs: Date.now() - started, result })
      window.__JL_AUTH_TIMINGS__ = timings.slice(-20)
    }
  }
}

// 登录页或尚未进入任何页面时才自动恢复，避免刷新业务表单。
// 必须能写入 sessionStorage 才自动刷新；两分钟内最多一次，防止循环。
export function recoverChunkLoad(error, canReload, browser) {
  if (!isChunkLoadError(error) || !canReload) return false
  if (!browser || (browser.navigator && browser.navigator.onLine === false)) return false
  try {
    const key = 'jl:chunk-recovery-at'
    const now = Date.now()
    const last = Number(browser.sessionStorage.getItem(key))
    if (last && now - last < 120000) return false
    browser.sessionStorage.setItem(key, String(now))
    if (browser.sessionStorage.getItem(key) !== String(now)) return false
    error.recoveryStarted = true
    browser.location.reload()
    return true
  } catch (storageError) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/authFlow.js